export const AUTO_SCROLL_TIMEOUT = 30 * 1000;
export const AUTO_SCROLL_SPEED = 0.2;
